<template>
  <Message
    :visible="lessonScores.length > 0"
    class="lesson-scores"
    :style="{ '--background-image-url': backgroundImageUrl }"
    :heading-size="2"
  >
    <template #heading>
      {{ $t('components.training.lesson-scores.heading') }}
      <TextToSpeech :text="$t('components.training.lesson-scores.heading')" />
    </template>
    <p>
      {{ $t('components.training.lesson-scores.description') }}
      <TextToSpeech
        :text="$t('components.training.lesson-scores.description')"
      />
    </p>
    <ul class="lesson-scores-list">
      <li
        v-for="lessonScore in lessonScores"
        :key="`lesson-score-${lessonScore.lessonId}`"
        class="lesson-scores-list-item"
      >
        <a
          class="lesson-scores-list-item-link"
          :href="lessonScore | lessonScoreLink"
          target="_blank"
          >{{ lessonScore.lessonName }}
          <TextToSpeech :text="lessonScore.lessonName" />
        </a>
      </li>
    </ul>
  </Message>
</template>

<script>
import Message from '@/components/ui/Message'
import TextToSpeech from '@/components/accessibility/TextToSpeech'

import { createSlug } from '@/utils/string'
import { getCdnImgUrlForCss } from '@/utils/style'
import config from '../../../config.json'

export default {
  name: 'LessonScores',
  components: { Message, TextToSpeech },
  props: {
    lessonScores: { type: Array, required: true },
  },
  computed: {
    backgroundImageUrl() {
      return getCdnImgUrlForCss('/fessor/images/Fessor_goodJob.png')
    },
  },
  filters: {
    lessonScoreLink(lessonScore) {
      if (!lessonScore) {
        return null
      }

      return `${config.studentSiteUrl}/lessons/${createSlug(
        lessonScore.lessonName,
        lessonScore.lessonId
      )}`
    },
  },
}
</script>

<style lang="scss" scoped>
.lesson-scores {
  background-image: var(--background-image-url);
  background-repeat: no-repeat;
  background-position: 90% bottom;
  background-size: auto 90%;
}

.lesson-scores-list-item-link {
  text-decoration: underline;
}
</style>
